export const PAGE_CONFIG = {
  "title": "Monthly",
  "titleCN": "运营总况月报",
  "subTitle": "",
  "subTitleCN": "",
  "path": "/overview/pcConsoleMonthV2",
  "defaultTab": "overall",
  "tabList": [
    {
      "id": "overall",
      "tabName": "Overall",
      "tabNameCN": "总览",
      "isHaveNotification": true,
      "notificationPath": "/overview/pcConsoleMonthV2",
      "path": "/overview/pcConsoleMonthV2/overall",
      "tabIcon": "chart-map",
      "logConfig": {
        "pageId": "204801",
        "pageName": "mothlyOverallV2",
        "extInfo": "mothlyOverallV2",
        "pagePath": "/overview/pcConsoleMonthV2/overall"
      },
      "filters": [
        {
          "name": "PcConsoleMonthlyFilter",
          "isOpenSticky": true,
          "isHaveFilterSave": true,
          "filterPath": "/overview/pcConsoleMonthV2/overall",
          "componentList": [
            {
              "name": "KeyMetricTitle",
              "className": "",
              "type": "view",
              "style": {},
              "props": {
                "config": {
                  "api": "/api/v1/dashboard/pc/overview_month/country_region_platform",
                  "metric": "mau"
                }
              }
            },
            {
              "name": "PlatformMetricsCo",
              "className": "margin-t-20",
              "type": "view",
              "style": {},
              "props": {
                "config": {
                  "api": "/api/v1/dashboard/pc/overview_month/card_metrics",
                  "metricsList": [
                    "active_users",
                    "new_users"
                  ]
                }
              },
              "children": [
                {
                  "name": "CommonRow",
                  "className": "",
                  "type": "layout",
                  "style": {},
                  "props": {},
                  "children": [
                    {
                      "name": "CommonCol",
                      "className": "",
                      "type": "layout",
                      "style": {},
                      "props": {
                        "w": 12
                      },
                      "children": [
                        {
                          "name": "PlatformCard",
                          "className": "",
                          "style": {},
                          "type": "view",
                          "props": {
                            "config": {
                              "componentMetrics": [
                                {
                                  "metricKey": "active_users",
                                  "enName": "MAU",
                                  "cnName": "月活跃",
                                  "rangeEnName": "Avg.MAU",
                                  "rangeCnName": "月平均活跃",
                                  "preUnit": "",
                                  "endUnit": "",
                                  "rainbowKey": "Pc MAU",
                                  "type": "int",
                                  "decimal": 0,
                                  "icon": "user-u",
                                  "position": ""
                                }
                              ]
                            }
                          },
                          "children": []
                        }
                      ]
                    },
                    {
                      "name": "CommonCol",
                      "className": "",
                      "type": "layout",
                      "style": {},
                      "props": {
                        "w": 12
                      },
                      "children": [
                        {
                          "name": "PlatformCard",
                          "className": "",
                          "style": {},
                          "type": "view",
                          "props": {
                            "config": {
                              "componentMetrics": [
                                {
                                  "metricKey": "new_users",
                                  "enName": "New",
                                  "cnName": "新进用户",
                                  "rangeEnName": "New",
                                  "rangeCnName": "新进用户",
                                  "preUnit": "",
                                  "endUnit": "",
                                  "rainbowKey": "Pc Metrics New",
                                  "type": "int",
                                  "decimal": 0,
                                  "icon": "user-plus",
                                  "position": ""
                                }
                              ]
                            }
                          },
                          "children": []
                        }
                      ]
                    }
                  ]
                }
              ]
            },
            {
              "name": "KeyMetricsCo",
              "className": "dbd-daily-card",
              "type": "view",
              "style": {},
              "props": {
                "config": {
                  "api": "/api/v1/dashboard/pc/overview_month/card_metrics",
                  "mainMetricsList": [
                    "median_online_time",
                    "pcu",
                    "m1t1"
                  ],
                  "metricsList": [
                    "median_online_time",
                    "median_session_time",
                    "above_2hr_users",
                    "pcu",
                    "dau_active_users_rate",
                    "acu",
                    "m1t1",
                    "m2t2",
                    "m3t3"
                  ]
                }
              },
              "children": [
                {
                  "name": "CommonRow",
                  "className": "",
                  "type": "layout",
                  "style": {},
                  "props": {},
                  "children": [
                    {
                      "name": "CommonCol",
                      "className": "",
                      "type": "layout",
                      "style": {},
                      "props": {
                        "w": 8
                      },
                      "children": [
                        {
                          "name": "MetricCard",
                          "className": "",
                          "style": {},
                          "type": "view",
                          "props": {
                            "config": {
                              "componentMetrics": [
                                {
                                  "metricKey": "median_online_time",
                                  "enName": "Median Playtime(h)",
                                  "cnName": "在线时长中位数(小时)",
                                  "rangeEnName": "Avg.Median Playtime(h)",
                                  "rangeCnName": "平均在线时长中位数(小时)",
                                  "preUnit": "",
                                  "endUnit": "H",
                                  "rainbowKey": "Pc V2 Metrics Playtime",
                                  "type": "decimals",
                                  "decimal": 2,
                                  "icon": "pie-chart-icon",
                                  "position": "",
                                  "isLeftCard": true
                                },
                                {
                                  "metricKey": "median_session_time",
                                  "enName": "Median Playtime Per Save(h)",
                                  "cnName": "单个存档在线时长(小时)",
                                  "rangeEnName": "Avg.Median Playtime Per Save(h)",
                                  "rangeCnName": "平均单个存档在线时长(小时)",
                                  "preUnit": "",
                                  "endUnit": "H",
                                  "rainbowKey": "Pc V2 Metrics Md.Playtime Per Save",
                                  "type": "decimals",
                                  "decimal": 2,
                                  "icon": "user-session",
                                  "position": ""
                                },
                                {
                                  "metricKey": "above_2hr_users",
                                  "enName": "Playtime over 2h+ new users",
                                  "cnName": "在线时长2小时以上新进用户数",
                                  "rangeEnName": "Avg.Playtime over 2h+ new users",
                                  "rangeCnName": "平均在线时长2小时以上新进用户数",
                                  "preUnit": "",
                                  "endUnit": "",
                                  "rainbowKey": "Pc Metrics Playtime over 2h+ new users",
                                  "type": "int",
                                  "decimal": 0,
                                  "icon": "",
                                  "position": ""
                                }
                              ]
                            }
                          },
                          "children": []
                        }
                      ]
                    },
                    {
                      "name": "CommonCol",
                      "className": "",
                      "type": "layout",
                      "style": {},
                      "props": {
                        "w": 8
                      },
                      "children": [
                        {
                          "name": "MetricCard",
                          "className": "",
                          "style": {},
                          "type": "view",
                          "props": {
                            "config": {
                              "componentMetrics": [
                                {
                                  "metricKey": "pcu",
                                  "enName": "PCU",
                                  "cnName": "最高同时在线",
                                  "rangeEnName": "Avg.PCU",
                                  "rangeCnName": "日平均最高同时在线",
                                  "preUnit": "",
                                  "endUnit": "",
                                  "rainbowKey": "Pc Metrics PCU",
                                  "type": "int",
                                  "decimal": 0,
                                  "icon": "user-pcu",
                                  "position": ""
                                },
                                {
                                  "metricKey": "dau_active_users_rate",
                                  "enName": "Avg.DAU/MAU",
                                  "cnName": "平均日活跃/月活跃",
                                  "rangeEnName": "Avg.DAU/Avg.MAU ",
                                  "rangeCnName": " 平均日活跃/平均月活跃",
                                  "preUnit": "",
                                  "endUnit": "",
                                  "rainbowKey": "Pc Avg.DAU/MAU",
                                  "type": "percent",
                                  "decimal": 2,
                                  "icon": "",
                                  "position": ""
                                },
                                {
                                  "metricKey": "acu",
                                  "enName": "ACU",
                                  "cnName": "平均同时在线",
                                  "rangeEnName": "ACU",
                                  "rangeCnName": "平均同时在线",
                                  "preUnit": "",
                                  "endUnit": "",
                                  "rainbowKey": "Pc Metrics ACU",
                                  "type": "int",
                                  "decimal": 0,
                                  "icon": "",
                                  "position": ""
                                }
                              ]
                            }
                          },
                          "children": []
                        }
                      ]
                    },
                    {
                      "name": "CommonCol",
                      "className": "",
                      "type": "layout",
                      "style": {},
                      "props": {
                        "w": 8
                      },
                      "children": [
                        {
                          "name": "MetricCard",
                          "className": "",
                          "style": {},
                          "type": "view",
                          "props": {
                            "config": {
                              "componentMetrics": [
                                {
                                  "metricKey": "m1t1",
                                  "enName": "M1(T-1)",
                                  "cnName": "次月留存(T-1)",
                                  "rangeEnName": "M1(T-1)",
                                  "rangeCnName": "次月留存(T-1)",
                                  "preUnit": "",
                                  "endUnit": "",
                                  "rainbowKey": "Pc M1(T-1)",
                                  "type": "percent",
                                  "decimal": 2,
                                  "icon": "user-success",
                                  "position": ""
                                },
                                {
                                  "metricKey": "m2t2",
                                  "enName": "M2(T-2)",
                                  "cnName": "2月留存(T-2)",
                                  "rangeEnName": "M2(T-2)",
                                  "rangeCnName": "2月留存(T-2)",
                                  "preUnit": "",
                                  "endUnit": "",
                                  "rainbowKey": "Pc M2(T-2)",
                                  "type": "percent",
                                  "decimal": 2,
                                  "icon": "user-success",
                                  "position": ""
                                },
                                {
                                  "metricKey": "m3t3",
                                  "enName": "M3(T-3)",
                                  "cnName": "3月留存(T-3)",
                                  "rangeEnName": "M3(T-3)",
                                  "rangeCnName": "3月留存(T-3)",
                                  "preUnit": "",
                                  "endUnit": "",
                                  "rainbowKey": "Pc M3(T-3)",
                                  "type": "percent",
                                  "decimal": 2,
                                  "icon": "user-success",
                                  "position": ""
                                }
                              ]
                            }
                          },
                          "children": []
                        }
                      ]
                    }
                  ]
                }
              ]
            },
            {
              "name": "EventService",
              "className": "",
              "type": "view",
              "style": {
                "marginTop": "10px"
              },
              "props": {},
              "children": [
                {
                  "name": "CommonRow",
                  "className": "",
                  "type": "layout",
                  "style": {},
                  "props": {},
                  "children": [
                    {
                      "name": "CommonCol",
                      "className": "",
                      "type": "layout",
                      "style": {},
                      "props": {
                        "w": 12
                      },
                      "children": [
                        {
                          "name": "OverviewMetricsTrendCo",
                          "className": "",
                          "type": "view",
                          "style": {},
                          "props": {
                            "config": {
                              "renderIndex": 0,
                              "api": {
                                "metricsApi": "/api/v1/dashboard/pc/overview_month/metrics_trend",
                                "dimensionApi": "/api/v1/dashboard/pc/overview_month/dimension/metrics_trend"
                              },
                              "componentMetrics": [
                                {
                                  "enName": "MAU",
                                  "cnName": "月活跃",
                                  "metricKey": "active_users",
                                  "type": "int",
                                  "decimal": 0
                                },
                                {
                                  "enName": "New",
                                  "cnName": "新进用户",
                                  "metricKey": "new_users",
                                  "type": "int",
                                  "decimal": 0
                                },
                                {
                                  "enName": "M1",
                                  "cnName": "次月留存",
                                  "metricKey": "m1",
                                  "type": "percent",
                                  "decimal": 2
                                },
                                {
                                  "enName": "M2",
                                  "cnName": "2月留存",
                                  "metricKey": "m2",
                                  "type": "percent",
                                  "decimal": 2
                                },
                                {
                                  "enName": "M3",
                                  "cnName": "3月留存",
                                  "metricKey": "m3",
                                  "type": "percent",
                                  "decimal": 2
                                },
                                {
                                  "enName": "TNU",
                                  "cnName": "总注册用户数",
                                  "metricKey": "total_users",
                                  "type": "int",
                                  "decimal": 0
                                },
                                {
                                  "enName": "PCU",
                                  "cnName": "最高同时在线",
                                  "metricKey": "pcu",
                                  "type": "int",
                                  "decimal": 0
                                },
                                {
                                  "enName": "ACU",
                                  "cnName": "平均同时在线",
                                  "metricKey": "acu",
                                  "type": "int",
                                  "decimal": 0
                                }
                              ]
                            }
                          }
                        }
                      ]
                    },
                    {
                      "name": "CommonCol",
                      "className": "",
                      "type": "layout",
                      "style": {},
                      "props": {
                        "w": 12
                      },
                      "children": [
                        {
                          "name": "OverviewMetricsTrendCo",
                          "className": "",
                          "type": "view",
                          "style": {},
                          "props": {
                            "config": {
                              "renderIndex": 1,
                              "api": {
                                "metricsApi": "/api/v1/dashboard/pc/overview_month/metrics_trend",
                                "dimensionApi": "/api/v1/dashboard/pc/overview_month/dimension/metrics_trend"
                              },
                              "componentMetrics": [
                                {
                                  "enName": "Median Playtime(h)",
                                  "cnName": "在线时长中位数(小时)",
                                  "metricKey": "median_online_time",
                                  "type": "decimals",
                                  "decimal": 2
                                },
                                {
                                  "enName": "Median Playtime Per Save(h)",
                                  "cnName": "单个存档在线时长(小时)",
                                  "metricKey": "median_session_time",
                                  "type": "decimals",
                                  "decimal": 2
                                }
                              ]
                            }
                          }
                        }
                      ]
                    }
                  ]
                }
              ]
            },
            {
              "name": "OverviewTableCo",
              "className": "",
              "type": "view",
              "style": {
                "marginTop": "20px"
              },
              "props": {
                "config": {
                  "api": {
                    "tableApi": "/api/v1/dashboard/pc/overview_month/overall_performance",
                    "tableDownloadApi": "/api/v1/dashboard/pc/overview_month/overall_performance/download"
                  },
                  "componentMetrics": [
                    {
                      "metricKey": "total_users",
                      "reqMetricKey": "total_users",
                      "enPercentWidth": 160,
                      "cnPercentWidth": 160,
                      "enWidth": 110,
                      "cnWidth": 130,
                      "enName": "TNU",
                      "cnName": "总注册用户数",
                      "rainbowKey": "Pc TNU",
                      "type": "int",
                      "decimal": 0,
                      "percentDecimals": 1
                    },
                    {
                      "metricKey": "active_users",
                      "reqMetricKey": "active_users",
                      "enPercentWidth": 160,
                      "cnPercentWidth": 160,
                      "enWidth": 110,
                      "cnWidth": 110,
                      "enName": "MAU",
                      "cnName": "月活跃",
                      "rainbowKey": "Pc MAU",
                      "type": "int",
                      "decimal": 0,
                      "percentDecimals": 1
                    },
                    {
                      "metricKey": "avg_active_users",
                      "reqMetricKey": "avg_active_users",
                      "enPercentWidth": 160,
                      "cnPercentWidth": 160,
                      "enWidth": 155,
                      "cnWidth": 130,
                      "enName": "Month Avg.DAU",
                      "cnName": "月平均日活跃",
                      "rainbowKey": "Month Avg.DAU",
                      "type": "int",
                      "decimal": 0,
                      "percentDecimals": 1
                    },
                    {
                      "metricKey": "new_users",
                      "reqMetricKey": "new_users",
                      "enPercentWidth": 160,
                      "cnPercentWidth": 160,
                      "enWidth": 110,
                      "cnWidth": 110,
                      "enName": "New",
                      "cnName": "新进用户",
                      "rainbowKey": "Pc New",
                      "type": "int",
                      "decimal": 0,
                      "percentDecimals": 1
                    },
                    {
                      "metricKey": "avg_new_users",
                      "reqMetricKey": "avg_new_users",
                      "enPercentWidth": 140,
                      "cnPercentWidth": 170,
                      "enWidth": 140,
                      "cnWidth": 170,
                      "enName": "Avg.Daily New",
                      "cnName": "平均每日新进用户数",
                      "rainbowKey": "Avg.Daily New",
                      "type": "int",
                      "decimal": 0,
                      "percentDecimals": 1
                    },
                    {
                      "metricKey": "m1",
                      "reqMetricKey": "m1",
                      "enPercentWidth": 155,
                      "cnPercentWidth": 155,
                      "enWidth": 85,
                      "cnWidth": 80,
                      "enName": "M1",
                      "cnName": "次月留存",
                      "rainbowKey": "Pc M1",
                      "type": "percent",
                      "decimal": 2,
                      "percentDecimals": 1
                    },
                    {
                      "metricKey": "m2",
                      "reqMetricKey": "m2",
                      "enPercentWidth": 155,
                      "cnPercentWidth": 155,
                      "enWidth": 85,
                      "cnWidth": 80,
                      "enName": "M2",
                      "cnName": "2月留存",
                      "rainbowKey": "Pc M2",
                      "type": "percent",
                      "decimal": 2,
                      "percentDecimals": 1
                    },
                    {
                      "metricKey": "m3",
                      "reqMetricKey": "m3",
                      "enPercentWidth": 155,
                      "cnPercentWidth": 155,
                      "enWidth": 85,
                      "cnWidth": 80,
                      "enName": "M3",
                      "cnName": "3月留存",
                      "rainbowKey": "Pc M3",
                      "type": "percent",
                      "decimal": 2,
                      "percentDecimals": 1
                    },
                    {
                      "metricKey": "pcu",
                      "reqMetricKey": "pcu",
                      "enPercentWidth": 160,
                      "cnPercentWidth": 160,
                      "enWidth": 85,
                      "cnWidth": 122,
                      "enName": "PCU",
                      "cnName": "最高同时在线",
                      "rainbowKey": "PCU",
                      "type": "int",
                      "decimal": 0,
                      "percentDecimals": 1
                    },
                    {
                      "metricKey": "acu",
                      "reqMetricKey": "acu",
                      "enPercentWidth": 160,
                      "cnPercentWidth": 160,
                      "enWidth": 85,
                      "cnWidth": 122,
                      "enName": "ACU",
                      "cnName": "平均同时在线",
                      "rainbowKey": "ACU",
                      "type": "int",
                      "decimal": 0,
                      "percentDecimals": 1
                    },
                    {
                      "metricKey": "median_online_time",
                      "reqMetricKey": "median_online_time",
                      "enPercentWidth": 175,
                      "cnPercentWidth": 175,
                      "enWidth": 175,
                      "cnWidth": 175,
                      "enName": "Median Playtime(h)",
                      "cnName": "在线时长中位数(小时)",
                      "rainbowKey": "Pc V2 Metrics Playtime",
                      "type": "decimals",
                      "decimal": 2,
                      "percentDecimals": 1
                    },
                    {
                      "metricKey": "above_2hr_users",
                      "reqMetricKey": "above_2hr_users",
                      "enPercentWidth": 250,
                      "cnPercentWidth": 250,
                      "enWidth": 250,
                      "cnWidth": 250,
                      "enName": "Playtime over 2h+ new users",
                      "cnName": "在线时长2小时以上新进用户数",
                      "rainbowKey": "Pc V2 Metrics Playtime over 2h+ new users",
                      "type": "int",
                      "decimal": 0,
                      "percentDecimals": 1
                    },
                    {
                      "metricKey": "median_session_time",
                      "reqMetricKey": "median_session_time",
                      "enPercentWidth": 250,
                      "cnPercentWidth": 190,
                      "enWidth": 250,
                      "cnWidth": 190,
                      "enName": "Median Playtime Per Save(h)",
                      "cnName": "单个存档在线时长(小时)",
                      "rainbowKey": "Pc V2 Metrics Md.Playtime Per Save",
                      "type": "decimals",
                      "decimal": 2,
                      "percentDecimals": 1
                    },
                    {
                      "metricKey": "retention_users",
                      "reqMetricKey": "retention_users",
                      "enPercentWidth": 196,
                      "cnPercentWidth": 130,
                      "enWidth": 196,
                      "cnWidth": 130,
                      "enName": "MAU Retention Users",
                      "cnName": "月活留存",
                      "rainbowKey": "MAU Retention Users",
                      "type": "int",
                      "decimal": 0,
                      "percentDecimals": 1
                    },
                    {
                      "metricKey": "churn_users",
                      "reqMetricKey": "churn_users",
                      "enPercentWidth": 160,
                      "cnPercentWidth": 160,
                      "enWidth": 130,
                      "cnWidth": 100,
                      "enName": "Churn Users",
                      "cnName": "月流失",
                      "rainbowKey": "Churn Users",
                      "type": "int",
                      "decimal": 0,
                      "percentDecimals": 1
                    },
                    {
                      "metricKey": "churn_rate",
                      "reqMetricKey": "churn_rate",
                      "enPercentWidth": 145,
                      "cnPercentWidth": 145,
                      "enWidth": 80,
                      "cnWidth": 86,
                      "enName": "Churn%",
                      "cnName": "流失率",
                      "rainbowKey": "Churn%",
                      "type": "percent",
                      "decimal": 2,
                      "percentDecimals": 1
                    },
                    {
                      "metricKey": "return_users",
                      "reqMetricKey": "return_users",
                      "enPercentWidth": 180,
                      "cnPercentWidth": 170,
                      "enWidth": 170,
                      "cnWidth": 95,
                      "enName": "MAU Return Users",
                      "cnName": "月回流",
                      "rainbowKey": "MAU Return Users",
                      "type": "int",
                      "decimal": 0,
                      "percentDecimals": 1
                    }
                  ]
                }
              }
            }
          ]
        }
      ]
    },
    {
      "id": "breakdown",
      "tabName": "Monthly Breakdown",
      "tabNameCN": "每月细分",
      "isHaveNotification": true,
      "notificationPath": "/overview/pcConsoleMonthV2",
      "path": "/overview/pcConsoleMonthV2/breakdown",
      "tabIcon": "pie-chart-icon",
      "logConfig": {
        "pageId": "204802",
        "pageName": "mothlyBreakdownV2",
        "extInfo": "mothlyBreakdownV2",
        "pagePath": "/overview/pcConsoleMonthV2/breakdown"
      },
      "filters": [
        {
          "name": "PcConsoleMonthlyFilter",
          "isOpenSticky": true,
          "isHaveFilterSave": true,
          "filterPath": "/overview/pcConsoleMonthV2/breakdown",
          "componentList": [
            {
              "name": "CommonRow",
              "className": "",
              "type": "layout",
              "style": {
                "marginTop": "10px"
              },
              "props": {},
              "children": [
                {
                  "name": "UserCompositionCo",
                  "className": "",
                  "type": "view",
                  "props": {
                    "config": {
                      "api": "/api/v1/dashboard/pc/overview_month/metrics_users"
                    }
                  },
                  "children": [
                    {
                      "name": "CommonCol",
                      "className": "",
                      "type": "layout",
                      "style": {},
                      "props": {
                        "w": 12
                      },
                      "children": [
                        {
                          "name": "MetricsUserCompositionCo",
                          "className": "",
                          "type": "view",
                          "style": {},
                          "props": {
                            "config": {
                              "timeType": "MONTH",
                              "metricType": "mau"
                            }
                          }
                        }
                      ]
                    },
                    {
                      "name": "CommonCol",
                      "className": "",
                      "type": "layout",
                      "style": {},
                      "props": {
                        "w": 12
                      },
                      "children": [
                        {
                          "name": "MetricsUserCompositionCo",
                          "className": "",
                          "type": "view",
                          "style": {},
                          "props": {
                            "config": {
                              "timeType": "MONTH",
                              "metricType": "system"
                            }
                          }
                        }
                      ]
                    }
                  ]
                }
              ]
            },
            {
              "name": "CommonRow",
              "className": "",
              "type": "layout",
              "style": {},
              "props": {},
              "children": [
                {
                  "name": "RankListTabCo",
                  "className": "",
                  "style": {},
                  "type": "view",
                  "data": {
                    "regionDataType": "os"
                  },
                  "children": [
                    {
                      "name": "MetricsRankListCo",
                      "className": "",
                      "type": "view",
                      "style": {},
                      "props": {
                        "config": {
                          "api": "/api/v1/dashboard/pc/overview_month/country_region_platform",
                          "metric": "mau",
                          "haveCalBubble": false,
                          "isUserQuota": true,
                          "showConfig": {
                            "showTable": true,
                            "showChart": true
                          }
                        }
                      }
                    },
                    {
                      "name": "MetricsRankListCo",
                      "className": "",
                      "type": "view",
                      "style": {},
                      "props": {
                        "config": {
                          "api": "/api/v1/dashboard/pc/overview_month/country_region_platform",
                          "metric": "new",
                          "haveCalBubble": false,
                          "isUserQuota": true,
                          "showConfig": {
                            "showTable": true,
                            "showChart": true
                          }
                        }
                      }
                    }
                  ]
                }
              ]
            }
          ]
        }
      ]
    }
  ]
}